import React from 'react'
import './ITOpsHero.scss'

export class ITOpsHero extends React.Component {
  render() {
    return (
      <div
        className="it-ops-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>IT Operations</h1>
            <h2>Enterprise-Scale Operations with 99.9%+ Availability</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default ITOpsHero
